import axios from 'axios';
import { getApiUrl } from '../config/runtime';

const getApiBaseUrl = () => getApiUrl();

export interface Channel {
  id: number;
  channel_id: string;
  platform: 'twitch' | 'youtube' | 'kick';
  channelName?: string;
  profilePicture?: string;
  notifications_count: number;
  created_at: Date;
  updated_at: Date;
}

class ChannelService {
  async getTopChannels(limit: number = 10): Promise<Channel[]> {
    const response = await axios.get(`${getApiBaseUrl()}/channels/top`, {
      params: { limit }
    });
    return response.data;
  }
}

export default new ChannelService();
